import { Container, Typography } from "@mui/material";

export function RefundCare() {
  return (
    <Container sx={{mb: 30}}>
      <Typography variant="h6" sx={{mb: 2}}>
          Refunds
      </Typography>
      <Typography variant="body1" sx={{mb: 1}}>
          All sales are final and generally non – exchangeable or refundable unless faulty in which case I will resolve the issue with you. 
      </Typography>
      <Typography variant="body1" sx={{mb: 1}}>
          Please note that all pieces are handmade; and due to the nature of enamel when fired there may be irregularities making each piece one of a kind which only adds to the beauty of pieces.
      </Typography>
      <Typography variant="body1" sx={{mb: 2}}>
          For hygiene reasons earrings are unable to be returned or exchanged, please choose carefully.
      </Typography>
    
      <Typography variant="h6" sx={{mb: 2}}>
          Care
      </Typography>
      <Typography variant="body1">
          Fused vitreous enamel is glass and should be treated as such. Do not drop, knock or store with anything that may scratch the surface. To clean wipe with a soft cloth. If tarnished, silver findings may be restored with a silver polishing cloth.
      </Typography>
    </Container>
    )}